<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex justify-space-between mb-2">
			<div class="d-flex align-center">
				<v-btn-toggle
					v-model="selectedType"
					dense
					mandatory
					class="d-flex flex-row custom-toggle-btns"
				>
					<v-btn :value="1" class="flex-grow-1"
						:color="selectedType == 1 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="selectedType == 1 ? 'white--text':''">Mis Empresas</p>
							<p class="mb-0 font-weight-bold" style="font-size: 9px;line-height: 9px" :class="selectedType == 1 ? 'white--text':''">Creadas por ti</p>
						</div>
					</v-btn>
					<v-btn :value="2" class="flex-grow-1"
						:color="selectedType == 2 ? '#FF120B':''">
						<div>
							<p class="mb-0 caption font-weight-bold" :class="selectedType == 2 ? 'white--text':''">Otras Empresas</p>
							<p class="mb-0 font-weight-bold" style="font-size: 9px;line-height: 9px" :class="selectedType == 2 ? 'white--text':''">Con las que trabajas</p>
						</div>
					</v-btn>
				</v-btn-toggle>
			</div>
			<div class="d-flex align-center justify-end flex-shrink-0 flex-grow-1">
				<div class="d-flex justify-center align-center mr-2">
					<v-checkbox
						v-model="showDeleted"
						class="my-0 py-0"
						small
						dense
						hide-details
						color="#FF120B"
						@change="reloadInfo"
					/>
					<p class="caption mb-0">Ver Empresas Eliminadas</p>
				</div>
				<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
					<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
					<v-text-field
						v-model="searchInput"
						:loading="$store.state.companies.loadingCompaniesList"
						outlined
						dense
						hide-details
						item-text="name"
						item-value="id"
						return-object
						clearable
						label="Búsqueda"
						class="mb-0 mr-2 custom-height-search custom-height-calendar"
						color="#524D4D"
						@input="sendToSearch"
					></v-text-field>
				</div>
				<DataTablePagination
					:options.sync="options"
					:item-length="$store.state.companies.companiesListCount"
					:loading-info="$store.state.companies.loadingCompaniesList"
				/>
			</div>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				ref="table"
				:headers="headers"
				:items="companiesList"
				item-key="id"
				:loading="$store.state.companies.loadingCompaniesList"
				:server-items-length="$store.state.companies.companiesListCount"
				:options.sync="options"
				loading-text="Cargando datos..."
				class="crm-table"
				:class="$vuetify.breakpoint.mobile ? '':'resizable'"
				disable-sort
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.name="{ item }">
					<div class="d-flex align-center">
						<v-avatar
							size="30"
						>
							<img :src="item.company.logo" class="user-avatar" v-if="item.company.logo"/>
							<v-icon v-else class="user-avatar icon" color="#524D4D" x-large>mdi-image</v-icon>
						</v-avatar>
						<p class="ml-2 mb-0">{{ item.company.name }}</p>
					</div>
				</template>
				<template v-slot:item.responsible="{ item }">
					<p class="mb-0" v-if="item.company.user_responsible && item.company.user_responsible.profile">
						{{item.company.user_responsible.profile.name }} {{item.company.user_responsible.profile.lastname }} {{item.company.user_responsible.profile.second_lastname }}
					</p>
					<p class="mb-0" v-else>
						Sin usuario seleccionado
					</p>
				</template>
				<template v-slot:item.actions="{ item }">
					<div class="d-flex align-center" v-if="$store.state.user.userInfo && !item.company.deleted_at">
						<div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="warning"
										class="mx-1"
										@click.stop="() => { selectRow(item); editCompany(item); }"
										v-bind="attrs"
										v-on="on"
										v-if="$checkPermissions(['edit_company']) && isMyCompany(item)"
									>
										<v-icon small dark>mdi-pencil</v-icon>
									</v-btn>
								</template>
								<span>Editar</span>
							</v-tooltip>
						</div>
						<div>
							<CompanyListConfig :isMyCompany="isMyCompany(item)" :company="item.company"/>
						</div>
						<div>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="error"
										class="mx-1"
										v-if="$checkPermissions(['delete_company']) && isMyCompany(item)"
										@click.stop="() => { selectRow(item); deleteCompany(item.company_id); }"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-delete-outline</v-icon>
									</v-btn>
								</template>
								<span>Eliminar</span>
							</v-tooltip>
						</div>
						<div v-if="userInfo?.super_admin_user">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										text
										x-small
										:color="item.company?.config?.supervision_allowed ? 'green':'#524D4D'"
										class="mx-1"
										v-bind="attrs"
										v-on="on"
										:disabled="supervisionLoading[item.company.id]"
										:dark="!supervisionLoading[item.company.id]"
										@click="toggleSupervision(item)"
									>
										<v-progress-circular v-if="supervisionLoading[item.company.id]" indeterminate size="12" width="2" :color="item.company?.config?.supervision_allowed ? 'green':'#524D4D'"></v-progress-circular>
										<v-icon small dark v-else>{{item.company?.config?.supervision_allowed ? 'mdi-check-circle-outline':'mdi-circle-outline'}}</v-icon>
										<p class="mb-0 ml-1" style="font-size: 10px;">
											Patrocinio
										</p>
									</v-btn>
								</template>
								<span>{{item.company?.config?.supervision_allowed ? 'Habilitar la sección de patrocinio' : 'Deshabilitar la sección de patrocinio'}}</span>
							</v-tooltip>
						</div>
					</div>
					<v-tooltip bottom v-if="item.company.deleted_at && $store.state.user.userInfo">
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="#524D4D"
								class="mx-1"
								@click.stop="() => { selectRow(item); startRestoreCompany(item); }"
								v-bind="attrs"
								v-on="on"
								v-if="$checkPermissions(['edit_company'])"
							>
								<v-icon small dark>mdi-archive-check-outline</v-icon>
							</v-btn>
						</template>
						<span>Restaurar</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="$store.state.companies.companiesListCount"
				:loading-info="$store.state.companies.loadingCompaniesList"
			/>
		</div> -->
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'
import {deleteCompany, updateCompany, restoreCompany} from '@/helpers/api/company'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import CompanyListConfig from '@/components/Views/Companies/CompanyListConfig'

export default {
	name: 'CompaniesIndex',
	components: {
		DataTablePagination,
		CompanyListConfig
	},
  data() {
    return {
			selectedType: 1,
			menuOpen: false,
      search: '',
			selectedRowItem: null,
			showDeleted: false,
			searchInput: null,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
			supervisionLoading: {},
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [],
      },
      headers: [
        { text: 'Nombre', value: 'name' },
        { text: 'Responsable', value: 'responsible' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
		userInfo() {
			return this.$store.state.user.userInfo
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		companiesList() {
			if(this.selectedType == 1){
				return this.$store.state.companies.companiesList.filter(c => c.company.responsible == this.$store.state.user.userInfo.id)
			}
			else if(this.selectedType == 2){
				return this.$store.state.companies.companiesList.filter(c => c.company.responsible != this.$store.state.user.userInfo.id)
			}
			return this.$store.state.companies.companiesList;
		},
    filteredUsers() {
      return this.$store.state.users.usersList.filter(user => {
        return (
          user.name.toLowerCase().includes(this.search.toLowerCase()) ||
          user.email.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
  },
	mounted(){
		const selectedRow = JSON.parse(localStorage.getItem('selected_companieslist_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		this.reloadInfo()
    eventBus.$on('reloadInformation', this.debounceReloadInfo)
	},
	beforeDestroy() {
		eventBus.$off('reloadInformation', this.debounceReloadInfo)
	},
  methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_companieslist_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		debounceReloadInfo: _debounce(function() { this.reloadInfo() }, 300),
		reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
				deleted: this.showDeleted
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
			this.$store.dispatch('companies/getCompaniesList', data)
		},
		async startRestoreCompany(company){
			await restoreCompany({restore_company_id: company.company_id})
			this.reloadInfo()
		},
		isMyCompany(company){
			if(this.$store.state.user.userInfo){
				return company.company.responsible == this.$store.state.user.userInfo.id
			}
			return false
		},
		async toggleSupervision(item) {
			const itemId = item.company.id
			try {
				this.$set(this.supervisionLoading, itemId, true)
				if (item.company?.config) {
					item.company.config.supervision_allowed = !item.company.config.supervision_allowed
				}
				const newValue = item.company?.config?.supervision_allowed
				let data = {
					update_company_id: item.company.id,
					supervision_allowed: newValue,
					...item.company
				}
				delete(data.logo)
				await updateCompany(data)
				this.$set(this.supervisionLoading, itemId, false)
				this.$store.dispatch('user/getUserInfo', {with_loading: false})
			} catch (error) {
				if (item.company?.config) {
					item.company.config.supervision_allowed = !item.company.config.supervision_allowed
				}
				this.$set(this.supervisionLoading, itemId, false)
			}
		},
    addCompany() {
			this.$store.commit('companies/setNewCompanyModal', true)
    },
    editCompany(company) {
			const data = {
				company_id: company.company.id,
				name: company.company.name,
				description: company.company.description,
				logo: company.company.logo,
				url: company.company.url,
				rut: company.company.rut,
				address: company.company.address,
				legal_name: company.company.legal_name,
				responsible: company.company.responsible,
				phone: company.company.phone,
				email: company.company.email,
				city_id: company.company.city_id,
				state_id: company.company.state_id,
				bank_account: company.company.bank_account,
				supervision_allowed: company.company.config?.supervision_allowed || false
			}
			this.$store.commit('companies/setNewCompanyModalEditing', data)
			this.$store.commit('companies/setNewCompanyModal', true)
    },
    async deleteCompany(delete_company_id) {
      await deleteCompany({delete_company_id})
			this.$store.dispatch('companies/getCompaniesList')
    }
  },
};
</script>

<style scoped>
</style>